"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4039],{

/***/ 34039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CookieMessage": function() { return /* binding */ CookieMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _demystdata_ui_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58278);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);




var CookieMessage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), hide = ref[0], setHide = ref[1];
    var getCookies = function() {
        var ref;
        return document === null || document === void 0 ? void 0 : (ref = document.cookie) === null || ref === void 0 ? void 0 : ref.split(";").map(function(v) {
            return v.split("=");
        }).reduce(function(acc, v) {
            var ref, ref1;
            acc[decodeURIComponent((ref = v[0]) === null || ref === void 0 ? void 0 : ref.trim())] = decodeURIComponent((ref1 = v[1]) === null || ref1 === void 0 ? void 0 : ref1.trim());
            return acc;
        }, {});
    };
    var handleAceptCookies = function() {
        document.cookie = "_manta_cookies=all;expires=".concat(new Date(Date.now() + 24 * 3600000 /* ms in hours */  * 365));
        setHide(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (getCookies()["_manta_cookies"] || hide || window.location.pathname === _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.MANAGE_COOKIE */ .s.MANAGE_COOKIE) setHide(!!getCookies()["_manta_cookies"] && window.location.pathname !== _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.MANAGE_COOKIE */ .s.MANAGE_COOKIE);
    }, []);
    if (hide) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cookies-message",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                "Demyst may serve cookies to analyze traffic to this site. Information about your use of this site is shared with Demyst for that purpose.",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_demystdata_ui_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            onClick: handleAceptCookies,
                            children: "Ok, Got it"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_demystdata_ui_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            onClick: function() {
                                return window.open(_constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.COOKIE_POLICY */ .s.COOKIE_POLICY);
                            },
                            children: "Cookie Policy"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_demystdata_ui_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            onClick: function() {
                                return window.open(_constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.MANAGE_COOKIE */ .s.MANAGE_COOKIE);
                            },
                            children: "Manage Cookies"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

}]);